import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

const ScanSortingToteResult_ = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("placed"),
    groupName: z.string(),
    toteName: z.string(),
  }),
  z.object({ status: z.literal("confirmed"), locationName: z.string() }),
  z.object({ status: z.literal("wrong_bin") }),
  z.object({ status: z.literal("wrong_tote") }),
  z.object({ status: z.literal("no_totes") }),
  z.object({ status: z.literal("not_found") }),
]);
export type ScanSortingToteResult = z.infer<typeof ScanSortingToteResult_>;

export const scanSortingTote = {
  name: "scanSortingTote" as const,
  input: z.object({
    identifier: z.string().min(1),
    scannedTote: z.string().min(1),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ result: ScanSortingToteResult_ }),
};
